import {
  IdentityRefDocument,
  IdentityRefFragment,
  IdentityRefFragmentDoc,
  IdentityRefQuery,
  IdentityRefQueryVariables,
  withStandardRefHook,
} from '@spotify/confidence-graphql';

export const useIdentityRef = withStandardRefHook<
  IdentityRefQuery,
  IdentityRefFragment,
  'identity',
  IdentityRefQueryVariables
>(
  IdentityRefDocument,
  'identity',
  IdentityRefFragmentDoc,
  'IdentityRef',
  'IamV1Identity',
);
